"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OTHER_MISC = void 0;
var entities_1 = require("@common/entities");
/** Generic schema for company-defined identification types without a system code. */
exports.OTHER_MISC = {
    name: 'other_misc_identification',
    label: 'Other / Miscellaneous Identification',
    customType: 'other_misc_identification',
    elementType: entities_1.SectionElementType.Block,
    fields: [
        {
            customType: entities_1.FieldType.Text,
            enabled: true,
            label: 'Identification Number',
            name: 'value',
            required: false,
            sequence: 1,
            type: entities_1.FieldType.Text,
        },
        {
            customType: entities_1.FieldType.Date,
            enabled: true,
            label: 'Issue Date',
            name: 'issue_date',
            required: false,
            sequence: 2,
            type: entities_1.FieldType.Date,
        },
        {
            customType: entities_1.FieldType.Date,
            enabled: true,
            label: 'Expiration Date',
            name: 'expiry_date',
            required: false,
            sequence: 3,
            type: entities_1.FieldType.Date,
        },
        {
            customType: entities_1.FieldType.CountryDropdown,
            enabled: true,
            label: 'Country',
            name: 'country_code',
            required: false,
            sequence: 4,
            type: entities_1.FieldType.CountryDropdown,
            options: [],
        },
        {
            customType: entities_1.FieldType.StateDropdown,
            enabled: true,
            label: 'State',
            name: 'state_code',
            required: false,
            sequence: 5,
            type: entities_1.FieldType.StateDropdown,
            options: [],
        },
    ],
};
